import { render, staticRenderFns } from "./InspectDepartmentCourse.vue?vue&type=template&id=0824b44e"
import script from "./InspectDepartmentCourse.vue?vue&type=script&lang=js"
export * from "./InspectDepartmentCourse.vue?vue&type=script&lang=js"
import style0 from "./InspectDepartmentCourse.vue?vue&type=style&index=0&id=0824b44e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports